import classNames from "classnames/bind";
import { IconProps } from "common/assets/icons/types";
import * as React from "react";
import styles from "./Icon.module.css";

const classNameBuilder = classNames.bind(styles);

export const SimpleArrowUpIcon: React.FC<IconProps> = ({
  color = "black",
  withBackground,
}) => {
  const renderContent = (): React.JSX.Element => {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none" fillRule="evenodd">
          <path d="M0 0h32v32H0z" />
          <path
            d="M15.45 12.235a.762.762 0 0 1 1.1 0l6.222 6.4a.815.815 0 0 1 0 1.13.762.762 0 0 1-1.099 0L16 13.933l-5.673 5.834a.762.762 0 0 1-1.099 0 .815.815 0 0 1 0-1.13l6.223-6.401Z"
            fill={color}
          />
        </g>
      </svg>
    );
  };

  if (withBackground) {
    return (
      <div
        className={classNameBuilder({
          withBackground,
          backgroundGray: withBackground,
        })}
      >
        {renderContent()}
      </div>
    );
  }

  return renderContent();
};
